import { render } from "./classroom-checking-selector.vue?vue&type=template&id=21cf62c9&scoped=true"
import script from "./classroom-checking-selector.vue?vue&type=script&lang=js"
export * from "./classroom-checking-selector.vue?vue&type=script&lang=js"

import "./classroom-checking-selector.vue?vue&type=style&index=0&id=21cf62c9&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cf62c9"]])

export default __exports__